export const StorageProvider = {

    LOCAL           : 0,
    AMAZON_DEFAULT  : 1,
    AMAZON_DEV      : 2,

    AMAZON_NORTH_AMERICA   : 10,
    AMAZON_SOUTH_AMERICA   : 11,
    AMAZON_EUROPE          : 12,
    AMAZON_ASIA            : 13,

    GOOGLE_DRIVE    : 100,
    DROPBOX         : 101, // never launched
    BOX_NEW         : 102, // never launched


    2   : {
        'label'             : 'DEV',
        'description'       : '',
        'httpUrl'           : 'https://s3-sa-east-1-goodday-work.s3.sa-east-1.amazonaws.com/',
        'generateUploadUrl' : 'https://scuhbuaag2.execute-api.sa-east-1.amazonaws.com/default/s3-sa-east-1-upload-url',
        'generateThumbnail' : 'https://scuhbuaag2.execute-api.sa-east-1.amazonaws.com/default/s3-sa-east-1-generate-thumbnails',
    },

    10  : {
        'label'             : 'North America',
        'description'       : '',
        'httpUrl'           : 'https://gd-north-america.s3.amazonaws.com/',
        'generateUploadUrl' : 'https://5kp2ddvjla.execute-api.us-east-1.amazonaws.com/generate-upload-url',
        'generateThumbnail' : 'https://5kp2ddvjla.execute-api.us-east-1.amazonaws.com/generate-thumbnails',
    },
    11  : {
        'label' : 'South America',
        'description'       : '',
        'httpUrl'           : 'https://gd-south-america.s3.amazonaws.com/',
        'generateUploadUrl' : 'https://04k4xw8655.execute-api.sa-east-1.amazonaws.com/generate-upload-url',
        'generateThumbnail' : 'https://04k4xw8655.execute-api.sa-east-1.amazonaws.com/generate-thumbnails',
    },
    12  : {
        'label' : 'Europe',
        'description'       : '',
        'httpUrl'           : 'https://gd-europe.s3.amazonaws.com/',
        'generateUploadUrl' : 'https://7vrzn6fzld.execute-api.eu-central-1.amazonaws.com/generate-upload-url',
        'generateThumbnail' : 'https://7vrzn6fzld.execute-api.eu-central-1.amazonaws.com/generate-thumbnails',
    },
    13  : {
        'label' : 'Asia / Pacific',
        'description'       : '',
        'httpUrl'           : 'https://gd-asia.s3.amazonaws.com/',
        'generateUploadUrl' : 'https://r7kigutrxd.execute-api.ap-south-1.amazonaws.com/generate-upload-url',
        'generateThumbnail' : 'https://r7kigutrxd.execute-api.ap-south-1.amazonaws.com/generate-thumbnails',
    },

    isS3Upload      : (storageProvider:any) => {
        return [2, 10, 11, 12, 13].includes(storageProvider)
    },

    isLocalUpload      : (storageProvider:any) => {
        return [0,1].includes(storageProvider)
    },

    generateUploadUrl   : (storageProvider:any) => {

        // @ts-ignore
        return StorageProvider[storageProvider].generateUploadUrl

        // switch (storageProvider) {
        //     case 2: return 'https://scuhbuaag2.execute-api.sa-east-1.amazonaws.com/default/s3-sa-east-1-upload-url'
        // }
    },

    generateThumbnailsUrl: (storageProvider:any):string => {

        // @ts-ignore
        return StorageProvider[storageProvider].generateThumbnail

        // switch (storageProvider) {
        //     case 2: return 'https://scuhbuaag2.execute-api.sa-east-1.amazonaws.com/default/s3-sa-east-1-generate-thumbnails'
        // }
    }

}